module.exports = __webpack_public_path__ + "static/media/CopyKeyFrame.25e259d5.svg";